(() => {
  if (customElements.get('onyx-field-guidance')) return;

  class OnyxFieldGuidance extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.branches = [...this.children].map((element) => ({
        element,
        launcher: element.querySelector('[data-hand-launcher], [data-inspection-launcher], [data-journey-launcher]'),
        button: element.querySelector('[data-hand-launch], [data-inspection-launch], [data-journey-launch]'),
      })).filter((branch) => branch.launcher && branch.button);
      this.observer = new MutationObserver((records) => this.sync(records));
      for (const branch of this.branches) {
        this.observer.observe(branch.button, { attributes: true, attributeFilter: ['aria-expanded'] });
        this.observer.observe(branch.launcher, { attributes: true, attributeFilter: ['hidden'] });
      }
      this.sync([]);
    }

    sync(records) {
      const opened = [...records].reverse().find((record) =>
        record.attributeName === 'aria-expanded' && record.target.getAttribute('aria-expanded') === 'true'
      );
      const selected = opened
        ? this.branches.find((branch) => branch.button === opened.target)
        : this.branches.find((branch) => branch.button.getAttribute('aria-expanded') === 'true');
      if (selected) {
        const focused = document.activeElement;
        for (const branch of this.branches) {
          if (branch !== selected && branch.button.getAttribute('aria-expanded') === 'true') {
            branch.element.close?.(false);
          }
        }
        if (focused?.isConnected && selected.element.contains(focused)) {
          focused.focus({ preventScroll: true });
        }
        if (opened) this.scrollIntoView({ block: 'start', behavior: 'auto' });
      }
      for (const branch of this.branches) {
        if (branch.launcher.hidden) branch.launcher.hidden = false;
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
    }
  }

  customElements.define('onyx-field-guidance', OnyxFieldGuidance);
})();
